window.chartColors = {
    red: 'rgb(255, 99, 132)',
    orange: 'rgb(255, 159, 64)',
    yellow: 'rgb(255, 205, 86)',
    green: 'rgb(75, 192, 192)',
    blue: 'rgb(54, 162, 235)',
    purple: 'rgb(153, 102, 255)',
    grey: 'rgb(201, 203, 207)'
};

$.expr[':'].textEquals = $.expr.createPseudo(function(arg) {
    return function( elem ) {
        return $(elem).text().trim().match("^" + arg + "$");
    };
});

// Navbar mobile transparention toggle on scroll

$.fn.fixNavbarMobile = function() {
    if(window.scrollY > 100 || $('.navbar-profile-company, body.mobile-search-open, body.mobile-main-menu-open').length){
        $('.navbar-homepage-mobile').addClass('bg-dark');
    } else {
        $('.navbar-homepage-mobile').removeClass('bg-dark');
    }
}

window.onscroll = function(e) {
    if(screen.width < 992){
        $.fn.fixNavbarMobile();
    }
}

$.fn.fixNavbarMobile();


// select with optional input
$.fn.selectWithOptionalInput = function () {
    this.each(function () {
        var suffix = '_optional_input';
        var source_select = $(this);
        var target_name = source_select.attr('name')+suffix;
        if(source_select.find('.editable[value="other"]').length == 0) {
            source_select.append('<option class="editable" value="other">+ Dodaj nową</option>');
            source_select.after('<input type="text" class="form-control" name="' + target_name + '" style="display:none;" placeholder="Wpisz nową pozycję" />')
            var source_select_editable = $(this).find('.editable');
            var target_input = $(this).siblings('[name="' + target_name + '"]');

            source_select.change(function () {
                var selected = $('option:selected', this).attr('class');
                var optionText = source_select_editable.text();

                if (selected == "editable") {
                    target_input.show().focus();
                    source_select.hide();
                    target_input.keyup(function () {
                        var editText = target_input.val();
                        source_select_editable.val(editText);
                        source_select_editable.html(editText);
                    });

                } else {
                    target_input.hide();
                }
            });

            if (source_select.find('option').length <= 1) {
                target_input.show().focus();
                source_select.hide();
                target_input.keyup(function () {
                    var editText = target_input.val();
                    source_select_editable.val(editText);
                    source_select_editable.html(editText);
                    source_select.val(editText)
                });
            }
        }
    });
};

$.loadRecommendedBoxLocation = function (location_name) {
    $.ajax({
        type    :"POST",
        url     :"/ajax/recommended/city",
        dataType:"json",
        data    :{
            location: location_name,
        },
        success :function(response){
            $('.recommended_box_city').removeClass('d-none').addClass('d-inline-block').wrap('<a href="'+response.city_url+'"></a>').html(response.city);
            $('.recommended_box_city_more').attr('href', response.city_url).removeClass('d-none');
            $('.recommended_box_content').html(response.box);
            if(response.slider.image){
                $('main .module_search').fadeTo('fast', 0.3, function(){
                    $(this).css("background-image", 'url("'+response.slider.image+'")');
                }).fadeTo('fast', 1);
            }
            if(response.slider.name && response.slider.url){
                if(!$('main .module_search .food-selection').hasClass('d-lg-flex')){
                    $('main .module_search .food-selection').fadeTo('fast', 0.3, function(){
                        $(this).addClass('d-lg-flex');
                    }).fadeTo('fast', 1);
                }
                $('main .module_search .food-selection a').attr('href', response.slider.url).text(response.slider.name);
            } else {
                if($('main .module_search .food-selection').hasClass('d-lg-flex')){
                    $('main .module_search .food-selection').fadeTo('fast', 0.7, function(){
                        $(this).removeClass('d-lg-flex');
                    }).fadeTo('fast', 0);
                }
            }
        },
    });
}

$.randomString = function(length) {
    var chars = "ABCDEFGHIJKLMNOPQRSTUVWXTZabcdefghiklmnopqrstuvwxyz";
    var string_length = length;
    var randomstring = '';
    for (var i=0; i<string_length; i++) {
        var rnum = Math.floor(Math.random() * chars.length);
        randomstring += chars.substring(rnum,rnum+1);
    }
    return randomstring;
}

$.cleanOpenedWindows = function (without){
    if(without != 'mobile-main-menu'){
        $('body').removeClass('mobile-main-menu-open');
    }
    if(without != 'mobile-search'){
        $('body').removeClass('mobile-search-open');
    }
    if(without != 'sidebar') {
        $(".sidebar").removeClass('toggled');
        $(".sidebar-toggle").addClass('collapsed');
    }
    else{
        $('.navbar .navbar-toggler').addClass('collapsed');
    }
}

// Login Alert
$.loginAlert = function () {
    Swal.fire({
        html: 'Aby skorzystać z tej funkcji <a class="btn btn-primary ml-1" href="https://zjedz.my/login">Zaloguj / zarejestruj się</a>',
    });
};

$.loadQuickBookingPanel = function(id, day, hour, people, kind) {
    document.body.insertAdjacentHTML('afterbegin', '<div id="zjedzmy-widget-wrap" class="zjedzmy-widget-bg"><div id="quick_booking_loading_indicator"><i class="fal fa-spinner fa-pulse"></i></div><iframe id="quick_booking_iframe" allowtransparency="true" frameborder="0" width="100%" height="100%" marginwidth="0" marginheight="0" src="'+$('[name="site-url"]').attr('content')+'/booking/' + id + '?day=' + ((typeof day !== 'undefined')?day:'') + '&hour=' + ((typeof hour !== 'undefined')?hour:'') + '&people=' + ((typeof people !== 'undefined')?people:'') + '&kind=' + ((typeof kind !== 'undefined')?kind:'') + '"></iframe></div>');

    var iframe = document.getElementById("quick_booking_iframe");
    var loading = document.getElementById("quick_booking_loading_indicator");
    iframe.style.display = "none";
    loading.style.display = "block";
    iframe.onload = function() {
        iframe.style.display = "";
        loading.style.display = "none";
    };
}

$.updateReservation = function(id) {
    document.body.insertAdjacentHTML('afterbegin', '<div id="zjedzmy-widget-wrap" class="zjedzmy-widget-bg"><div id="quick_booking_loading_indicator"><i class="fal fa-spinner fa-pulse"></i></div><iframe id="quick_booking_iframe" allowtransparency="true" frameborder="0" width="100%" height="100%" marginwidth="0" marginheight="0" src="'+$('[name="site-url"]').attr('content')+'/booking/update-reservation/' + id + '"></iframe></div>');

    var iframe = document.getElementById("quick_booking_iframe");
    var loading = document.getElementById("quick_booking_loading_indicator");
    iframe.style.display = "none";
    loading.style.display = "block";
    iframe.onload = function() {
        iframe.style.display = "";
        loading.style.display = "none";
    };
}

$.shortIconAnimation = function(el, animation){
    el.addClass('faa-'+animation+' faa-fast animated');
    setTimeout(function () {
        el.removeClass('faa-'+animation+' faa-fast animated');
    },(animation=='flash')?500:1000);
}

$.closeQuickBookingPanelFromTheIframe = function() {
    if(window.frameElement){
        window.parent.document.getElementById('zjedzmy-widget-wrap').parentNode.removeChild(window.parent.document.getElementById('zjedzmy-widget-wrap'));
    }
    else {
        // Walkaround for: SecurityError: Blocked a frame with origin from accessing a cross-origin frame
        window.parent.postMessage({
            'action': 'closeQuickBookingPanel',
        }, "*");
    }
}

// Detect iframe
if (window.parent !== window) {
    document.documentElement.classList.add('inside-iframe');
}

$(document).ready(function () {
    // Tooltips
    $('[data-toggle="tooltip"]').tooltip();

    // IOS doubletap fix for bootstrap tooltip
    $("[data-toggle=tooltip]").on('show.bs.tooltip', function (e) {
        if ('ontouchstart' in document.documentElement) {
            e.preventDefault();
        }
    });

    // CSRF token
    $.ajaxSetup({
        headers: {
            'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
        }
    });



    // Favoriteable
        $(document).on('click', '.favoriteable', function(){
            if(user_id){
                var button = $(this);
                $.ajax({
                    type: 'POST',
                    url: '/ajax/favorite/'+$(this).data('favoriteable')+'/'+$(this).data('id'),
                    data: {},
                    dataType: 'JSON',
                    success: function (data) {
                        if(data.state){
                            button.find('.fa-inverse').removeClass('far').addClass('fas');
                        }
                        else{
                            button.find('.fa-inverse').removeClass('fas').addClass('far');
                        }
                    },
                    error : function (data) {
                        alert('Brak uprawnień');
                    },
                    beforeSend: function(){
                        button.find('.fa-inverse').addClass('faa-pulse animated')
                    },
                    complete: function(){
                        button.find('.fa-inverse').removeClass('faa-pulse animated')
                    }
                });
            } else{
                $.loginAlert();
            }
        });


    // Favoriteable
    $('.toggle_comment_publicity').each(function(){
        if(user_id){
            var button = $(this);
            button.click(function(){
                $.ajax({
                    url: '/ajax/comment/toggle_publicity/'+button.data('id'),
                    type: 'POST',
                    data: {},
                    dataType: 'JSON',
                    success: function (data) {
                        if(data.state){
                            button.parents('.comment_box').removeClass('unpublic');
                        }
                        else{
                            button.parents('.comment_box').addClass('unpublic');
                        }
                    },
                    error : function (data) {
                        alert('Brak uprawnień');
                    }
                });
            });
        } else{
            $.loginAlert();
        }
    });

    // Parallaxie
    $('.parallaxie').parallaxie();

    $('a[href="'+decodeURIComponent(window.location.href)+'"]').each(function(){
        $(this).addClass('active');
    });

    // Keep tabs open
    function openNestedTabHref(hash){
        var res = hash.split("__");
        var res_length = res.length;
        $.each(res, function (index, element) {
            if(!element.startsWith('#')){
                element = '#'+element;
            }
            $('[role="tab"][href="' + element + '"]').tab('show');
            if(index === (res_length - 1)){
                setTimeout(function() {
                    $('html, body').animate({
                        scrollTop: $('[href="'+element+'"]').offset().top - 10 +'px'
                    }, 'fast');
                }, 500);
            }
        });
    }
    $('[data-open-nested-tab-href]').click(function(){
        openNestedTabHref($(this).data('openNestedTabHref'));
    });

    $('[role="tab"]').on('shown.bs.tab', function (e) {
        var hash = $(e.target).attr('href');
        if (history.pushState) {
            history.pushState(null, null, hash);
        } else {
            location.hash = hash;
        }
    });

    var hash = window.location.hash;
    if (hash) {
        // nested tabs
        if(hash.includes('__')){
            openNestedTabHref(hash);
        }
        // single tab
        else{
            $('[role="tab"][href="' + hash + '"]').tab('show');
        }
    }

    // Fullscreen menu
    $('.mobile-main-menu-trigger').click(function(){
        $.cleanOpenedWindows('mobile-main-menu');
        $('body').removeClass('mobile-search-open').toggleClass('mobile-main-menu-open');
        $('.mobile-trigger').addClass('collapsed');
        if($('body').hasClass('mobile-main-menu-open')){
            $('.mobile-main-menu-trigger').removeClass('collapsed');
        } else{
            $('.mobile-main-menu-trigger').addClass('collapsed');
        }
        $.fn.fixNavbarMobile();
    });

    // Fullscreen search
    $('.mobile-search-trigger').click(function(){
        $.cleanOpenedWindows('mobile-search');
        $('body').removeClass('mobile-main-menu-open').toggleClass('mobile-search-open');
        $('.mobile-trigger').addClass('collapsed');
        if($('body').hasClass('mobile-search-open')){
            $('.mobile-search-trigger').removeClass('collapsed');
        } else{
            $('.mobile-search-trigger').addClass('collapsed');
        }
        $.fn.fixNavbarMobile();
    });


    // Ocenianie
    $('.starrr').each(function () {
        $(this).starrr({
            max: $(this).data('max') || 5,
            readOnly: $(this).data('vote')? false : true,
            rating: $(this).data('rating') || void 0,
            fullClass: 'fas fa-star starrr',
            emptyClass: 'far fa-star starrr text-muted',
        });
        if($(this).data('vote')){
            $(this).on('starrr:change', function(e, value){
                $('input[name="'+$(this).data('vote')+'"]').val(value)
            });
        }
    });

    // REZERWACJA
    $(document).on('click', '.quick_booking_ajax', function(){
        Swal.close();
        var clicked = $(this);

        if(clicked.data('update-reservation')){
            $.updateReservation(clicked.data('update-reservation'));
        } else {
            // auto set date & kind for nearest open slot
            var day = clicked.data('day')?clicked.data('day'):$('.nearest_open_day[data-id="'+clicked.data('id')+'"]:first').data('day');
            var kind = clicked.data('kind')?clicked.data('kind'):$('.nearest_open_day[data-id="'+clicked.data('id')+'"]:first').data('kind');
            $.loadQuickBookingPanel(clicked.data('id'), day, clicked.data('hour'), clicked.data('people'), kind);
        }
    });

    // Auto add cart counter to buttons:
    function updateCartCounter(cart_counter){
        var cart_key = 'cart_company_'+cart_counter.data('id');
        var totalCount = 0;
        if (localStorage.getItem(cart_key) != null) {
            cart = JSON.parse(localStorage.getItem(cart_key));
            for(var item in cart) {
                totalCount += cart[item].count;
            }
            if(totalCount > 0){
                if(cart_counter.find('.quick_booking_cart_counter').length){
                    if(parseInt(cart_counter.find('.quick_booking_cart_counter').text()) != totalCount){
                        cart_counter.find('.quick_booking_cart_counter').html('<i class="fal fa-shopping-cart"></i> '+totalCount);
                        $.shortIconAnimation($('.quick_booking_cart_counter .fa-shopping-cart'), 'tada');
                    }
                } else {
                    cart_counter.append('<span class="ml-4 quick_booking_cart_counter"><i class="fal fa-shopping-cart mr-1"></i> '+totalCount+'</span>');
                }
            } else {
                cart_counter.find('.quick_booking_cart_counter').remove();
            }
        }
    }

    $('.quick_booking_cart_count').each(function () {
        updateCartCounter($(this));
        window.setInterval(() => updateCartCounter($(this)), 1500);
    });

    // Form-editable
    $(document).on('change', '.form_editable input, .form_editable select, .form_editable textarea', function(){
        $.ajax({
            url: $(this).parents('.form_editable').data('save-url'),
            type: 'POST',
            dataType: 'json',
            data: {
                'name': $(this).attr('name'),
                'value': ($(this).is(':checkbox')?($(this).is(":checked")?1:0):$(this).val()),
                'details': $(this).data('details'),
                'details2': $(this).data('details2'),
            },
            success: function (data) {
                var responseText = '';
                $.each(data.response, function( index, value ) {
                    responseText += value+'<br/>';
                });
                Swal.fire({
                    icon: 'success',
                    title: responseText,
                    toast: true,
                    position: 'top-end',
                    showConfirmButton: false,
                    timer: 3000,
                })
            },
            error: function (jqXHR, textStatus, errorThrown) {
                var responseJson = jQuery.parseJSON(jqXHR.responseText);
                var responseText = '';
                $.each(responseJson.response, function( index, value ) {
                    responseText += value+'<br/>';
                });
                Swal.fire({
                    icon: 'error',
                    html: responseText,
                })
            },
            beforeSend:function(){
                $("#loading-indicator").fadeIn('fast');
            },
            complete:function(){
                $("#loading-indicator").fadeOut('fast');
            }
        });
    });

    // select with optional input
    $('[data-select-with-optional-input]').selectWithOptionalInput();

    // reservation cancel reason choose

    $(document).on('click', '.reservation_cancel_reason_choose', function(e){
        e.preventDefault();
        var form = $(this);
        function processCancelReason(reason){
            if(reason){
                form.prepend('<input type="hidden" name="reason" value="'+reason+'" />');
                form.submit();
            }
        };

        if(form.hasClass('reservation_cancel_company')){
            var inputOptionsValues = {
                'Lokal przepełniony. Zapraszamy w innym terminie': 'Lokal przepełniony. Zapraszamy w innym terminie',
                'Zdublowana rezerwacja': 'Zdublowana rezerwacja',
                'Pomyłka': 'Pomyłka',
                'other': 'Inny',
            };
        } else {
            var inputOptionsValues = {
                'Rezygnacja bez podania powodu': 'Rezygnacja bez podania powodu',
                'Rezerwacja w innym terminie': 'Rezerwacja w innym terminie',
                'Pomyłka': 'Pomyłka',
                'other': 'Inny',
            };
        }


        Swal.fire({
            icon: 'question',
            title: 'Wybierz powód odwołania',
            input: 'select',
            inputOptions: inputOptionsValues,
            showCancelButton: true,
            cancelButtonText: 'Anuluj'
        }).then((result) => {
            if (result.value === 'other') {
                Swal.fire({
                    title: 'Podaj powód odwołania',
                    input: 'text',
                    showCancelButton: true,
                    inputValidator: (value) => {
                        if (!value) {
                            return 'Musisz podać powód odwołania'
                        }
                    }
                }).then((result) => {
                    processCancelReason(result.value);
                });
            } else {
                processCancelReason(result.value);
            }
        });
    });

    function getDistanceFromLatLonInKm(lat1,lon1,lat2,lon2) {
        var R = 6371; // Radius of the earth in km
        var dLat = deg2rad(lat2-lat1);  // deg2rad below
        var dLon = deg2rad(lon2-lon1);
        var a =
            Math.sin(dLat/2) * Math.sin(dLat/2) +
            Math.cos(deg2rad(lat1)) * Math.cos(deg2rad(lat2)) *
            Math.sin(dLon/2) * Math.sin(dLon/2)
        ;
        var c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1-a));
        var d = R * c; // Distance in km
        return d;
    }

    function deg2rad(deg) {
        return deg * (Math.PI/180)
    }

    // Geolokalizacja

    function getUrlParam(name) {
        var results = new RegExp('[\\?&]' + name + '=([^&#]*)').exec(window.location.href);
        return (results && results[1]) || undefined;
    }

    function getUrlSegment(num) {
        num += 2;
        var segments = window.location.href.toString();
        if (segments.indexOf('?') > -1)
        {
            segments = segments.substring(0,window.location.href.indexOf("?"));
        }
        segments = segments.split('/');
        if (segments[num] != undefined) {
            return segments[num];
        }
        return undefined;
    }

    function isLocationFilterSet() {
        return ((typeof(getUrlParam('search_filter_location')) !== 'undefined') || (getUrlSegment(1) == 'restauracje' && getUrlSegment(2) == 'w' && getUrlSegment(3)) );
    }

    var geo = navigator.geolocation;
    if(geo && typeof cities !== 'undefined') {
        geo.getCurrentPosition(function(location) {
            var nearest_distance = 40000;
            var nearest_city = null;

            $.each(cities, function( index, value ) {
                var city_distance = getDistanceFromLatLonInKm(location.coords.latitude, location.coords.longitude, parseFloat(value.latitude.replace(',','.').replace(' ','')),parseFloat(value.longitude.replace(',','.').replace(' ','')));
                if(city_distance < nearest_distance){
                    nearest_distance = city_distance;
                    nearest_city = value;
                }
            });

            // set city only if not choosen previously

            console.info('Twoja lokalizacja (dokładność: '+location.coords.accuracy+' m): https://www.google.com/maps/search/?api=1&query='+location.coords.latitude.toString().replace(",", ".")+','+location.coords.longitude.toString().replace(",", "."));
            console.info('Najbliższe miasto: '+ nearest_city.value+' ('+nearest_distance+' km dalej) https://www.google.com/maps/search/?api=1&query='+nearest_city.latitude.toString().replace(",", ".")+','+nearest_city.longitude.toString().replace(",", ".")+'">'+nearest_city.latitude+','+nearest_city.longitude);

            if (nearest_city.value && (location.coords.accuracy < 50000) && !isLocationFilterSet()) {
                $('select[name="search_filter_location"]').val(nearest_city.value);
                $.loadRecommendedBoxLocation(nearest_city.value);
                $("meta[name='location']").attr("content", nearest_city.value);
            }

        });
    }

    // WEB SHARE API button
    $('.share-page-button').click(function() {
        if(navigator.share) {
            navigator.share({
                title: $('meta[property="og:title"]').attr('content'),
                text: $('meta[property="og:description"]').attr('content'),
                url: $('meta[property="og:url"]').attr('content'),
            });
        }
    });


    // Smooth scroll

    $('.smooth_scroll:not([href=\\#])').click(function() {
        if (location.pathname.replace(/^\//,'') == this.pathname.replace(/^\//,'') && location.hostname == this.hostname) {
            var target = $(this.hash);
            target = target.length ? target : $('[name=' + this.hash.slice(1) +']');
            if (target.length) {
                $('html,body').animate({
                    scrollTop: target.offset().top-70
                }, 400);
                return false;
            }
        }
    });

    // smart collapse with more/less
    $('.collapse-smart').each(function(){
        if($(this).height() < 250){
            // $(this).removeClass('collapse-preview-wrap collapse');
        }
        else{
            var id = $.randomString(10);
            $(this)
                .addClass('collapse collapse-smart-wrap')
                .attr('id', id)
                .after('<a role="button" class="collapsed collapse-smart-button" data-toggle="collapse" href="#'+id+'"></a>');
        }
    });

    // nearest hours ajax
    $(document).on('click', '.kind-icon', function (e){
        var wrapper = $(this).parents('.nearest_hours').first();
        var company_id = wrapper.data('id');
        var half_column = wrapper.data('half-column');
        var active_kind = $(this).data('kind');
        $(this).addClass('active').siblings('.kind-icon').removeClass('active');
        $.ajax({
            url: wrapper.data('action'),
            type: "POST",
            data: {
                'kind': active_kind,
                'half_column': half_column,
            },
            beforeSend:function(){
                // $("#loading-indicator").fadeIn('fast');
            },
            complete:function(){
                // $("#loading-indicator").fadeOut('fast');
            },
            success: function (data) {
                wrapper.replaceWith(data);
                $('.tooltip').remove();
                setTimeout(function() {
                    $('body').tooltip({
                        selector: '[data-toggle="tooltip"]'
                    });
                }, 1000);

                // auto set kind for corresponding quick bookin buttons
                $('.btn.quick_booking_ajax[data-id="'+company_id+'"]').data('kind', active_kind);
            },
            error: function (jqXHR, textStatus, errorThrown) {
                Swal.fire({
                    icon: 'error',
                    html: 'Wystąpił błąd',
                })
            }
        });
    });

    // Scroll to top
    $(window).scroll(function () {
        if ($(this).scrollTop() > 50) {
            // company page fix
            if($('.sticky-company-booking-mobile:visible').length) {
                $('.scroll_top_arrow').css('bottom', '80px');
            }

            $('.scroll_top_arrow:hidden').fadeIn();
        } else {
            $('.scroll_top_arrow').fadeOut();
        }
    });
    $(function () {
        $(".scroll_top_arrow").click(function () {
            $("html,body").animate({scrollTop: $("body").offset().top}, "1000");
            return false;
        })
    })
});

// Reservation chat
function getReservationChat(id){
    $.ajax({
        type    :"POST",
        url     : '/reservation/get_chat/'+id,
        success :function(response){
            $('.reservation_chat_wrap[data-id="'+id+'"]').html(response).scrollTop($('.reservation_chat_wrap[data-id="'+id+'"]')[0].scrollHeight);
        }
    });
}

setInterval(function(){
    $('.reservation_chat_wrap').each(function (){
        if($(this).data('autorefresh')){
            getReservationChat($(this).data('id'));
        }
    });
},15000);

$(document).on('submit', 'form.reservation_chat_form', function (e){
    e.preventDefault();
    var form = $(this);
    $.ajax({
        url: form.attr('action'),
        type: "POST",
        data: form.serialize(),
        beforeSend:function(){
            $("#loading-indicator").fadeIn('fast');
        },
        complete:function(){
            $("#loading-indicator").fadeOut('fast');
        },
        success: function(response) {
            getReservationChat(form.data('id'));
            form.find('textarea').val('');
        },
        error: function(data) {
            Swal.fire({
                icon: 'error',
                html: 'Wystąpił błąd',
            })
        }
    });
})